import { Icon } from '../../components/Icon'
import type { LocalChannel } from '../../db/db'
import { dmPartnerId, type UserMap } from '../../lib/channels'
import { quietLabel } from '../channels/quiet'

/**
 * In a one-to-one conversation, whether the person being written to will hear about it. It sits above the message box,
 * where someone is deciding whether to rely on a message arriving, and says when they will be notified again. A bot has
 * no notifications, so it never appears in a bot conversation.
 */
export function QuietPartnerNote({ channel, users, meId }: { channel: LocalChannel; users: UserMap; meId: string | null }) {
  if (channel.type !== 'dm') return null
  const partnerId = dmPartnerId(channel, meId, users)
  const name = (partnerId ? users.get(partnerId)?.displayName : null) ?? 'They'
  const text = quietLabel(channel.partnerQuiet ?? null, 'partner', Date.now(), name)
  if (!text) return null
  return (
    <div className="quiet-note" role="note">
      <Icon name="mute" />
      <span>{text}</span>
    </div>
  )
}
